/* Tmarat — cart drawer "add to your order" recommendations */
(function () {
  if (customElements.get('tmarat-cart-upsell')) return;

  class TmaratCartUpsell extends HTMLElement {
    connectedCallback() {
      if (!this._bound) {
        this._bound = true;
        this.addEventListener('change', this.onChange.bind(this));
        this.addEventListener('click', this.onClick.bind(this));
      }
      if (this._loaded) return;

      var drawer = this.closest('m-cart-drawer');
      var isOpen = drawer && drawer.classList.contains('m-cart-drawer--active');
      var events = window.MinimogEvents;
      var theme = window.MinimogTheme;
      var canWait = drawer && events && typeof events.subscribe === 'function' &&
        theme && theme.pubSubEvents && theme.pubSubEvents.openCartDrawer;

      if (isOpen || !canWait) {
        this.load();
        return;
      }
      // Only fetch recommendations once the drawer is actually opened.
      var self = this;
      this._unsubscribe = events.subscribe(theme.pubSubEvents.openCartDrawer, function () {
        self.stopWaiting();
        self.load();
      });
    }

    disconnectedCallback() {
      this.stopWaiting();
    }

    stopWaiting() {
      if (typeof this._unsubscribe === 'function') this._unsubscribe();
      this._unsubscribe = null;
    }

    load() {
      if (this._loaded) return;
      this._loaded = true;
      var productId = this.dataset.productId;
      var base = this.dataset.url;
      if (!productId || !base) return;
      var url = base + (base.indexOf('?') === -1 ? '?' : '&') +
        'section_id=tmarat-cart-upsell&limit=10&product_id=' + encodeURIComponent(productId);
      var self = this;
      fetch(url)
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (html) {
          if (!html) return;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var inner = doc.querySelector('.tmarat-upsell__inner');
          if (!inner || !inner.querySelector('.tmarat-upsell__card')) return;
          self.innerHTML = inner.innerHTML;
        })
        .catch(function () {});
    }

    onChange(event) {
      var select = event.target.closest('[data-upsell-select]');
      if (!select) return;
      // Keep the theme's cart-items listener from treating this as a quantity change.
      event.stopPropagation();
      var card = select.closest('.tmarat-upsell__card');
      var button = card && card.querySelector('[data-upsell-add]');
      var option = select.options[select.selectedIndex];
      if (button) button.dataset.variantId = select.value;
      var price = card && card.querySelector('[data-upsell-price]');
      if (price && option && option.dataset.price) price.textContent = option.dataset.price;
    }

    onClick(event) {
      var button = event.target.closest('[data-upsell-add]');
      if (!button) return;
      event.preventDefault();
      event.stopPropagation();
      if (button.disabled) return;
      button.disabled = true;
      button.classList.add('is-loading');

      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(button.dataset.variantId), quantity: 1 }] })
      })
        .then(function (r) {
          return r.json().then(function (data) { return { ok: r.ok, data: data }; });
        })
        .then(function (res) {
          if (!res.ok) {
            throw new Error((res.data && (res.data.description || res.data.message)) || 'Error');
          }
          var drawer = document.querySelector('m-cart-drawer');
          if (drawer && typeof drawer.onCartDrawerUpdate === 'function') {
            drawer.onCartDrawerUpdate();
          } else {
            window.location.href = root + 'cart';
          }
        })
        .catch(function (err) {
          button.disabled = false;
          button.classList.remove('is-loading');
          var theme = window.MinimogTheme;
          if (theme && theme.Notification && typeof theme.Notification.show === 'function') {
            theme.Notification.show({
              target: button.closest('.tmarat-upsell__card'),
              type: 'warning',
              message: err.message
            });
          }
        });
    }
  }

  customElements.define('tmarat-cart-upsell', TmaratCartUpsell);
})();
